import React from 'react';

import { Badge, Tooltip, Typography } from '@mui/material';

import ChromeOperation from '@public/images/ChromeOperation.jpg';

import { IWarningButtonBadge } from './interfaces';

import { useStyles } from './styles';

const WarningButtonBadge = ({
  children,
  classes = {},
  isHidden = false,
}: IWarningButtonBadge) => {
  const mainClasses = useStyles();

  const { tooltip = {} } = classes;

  return (
    <Badge
      badgeContent={
        <Tooltip
          title={<img width="400" height="500" src={ChromeOperation} alt="" />}
          arrow
          placement="top"
          sx={tooltip}
        >
          <Typography>!</Typography>
        </Tooltip>
      }
      color="error"
      sx={mainClasses.badge(isHidden)}
    >
      {children}
    </Badge>
  );
};

export default WarningButtonBadge;
